import React, { useEffect, useState } from "react";
import { Endpoints } from '../../../Global/Endpoints';
import axios from 'axios';
import { useLocation } from "react-router-dom";
import WinLogo from "../../../assets/images/win/logo-win.svg";
import Preview1 from "../../../assets/images/win/ExpertDTC.png";
import Preview2 from "../../../assets/images/win/NurseCareDTC.png";
import Preview3 from "../../../assets/images/win/EducationalDTC.png";
import Preview5 from "../../../assets/images/win/BehaviouralDTC.png";
import Preview6 from "../../../assets/images/win/HealthCoachingDTC.png";
import Preview8 from "../../../assets/images/win/WINFamilyAPPDTC.png";

import { useNavigate } from "react-router-dom";

const Paymentstep = () => {

  const portalLogo = WinLogo;
  const location = useLocation();
  const {updatedProviderData,otherData} = location.state;
  const [currentStep, setCurrentStep] = useState(1);
  const totalSteps = 8;
  const [serviceAmounts, setServiceAmounts] = useState(null);
  const [amount, setAmount] = useState(null);
  const navigate = useNavigate();

  // Always pass updatedProviderData and otherData in navigation
  const goNext = () => {
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
    } else {
      navigate("/payment", { state: { updatedProviderData, otherData: { ...otherData, amount } } });
    }
  };

  useEffect(() => {
    if (otherData && otherData.amount) {
      setAmount(otherData.amount);
    }
  }, [otherData]);

  // Always pass updatedProviderData and otherData in navigation
  const goBack = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1)
    else navigate('/referral-source',
      { state: { updatedProviderData, otherData: { ...otherData, amount } } });
  };

  const getServiceAmount = async () => {
    try {
      const params = {
        EmailId: updatedProviderData?.EmailID,
      };
      const response = await axios.post(
        Endpoints.UKDTCServiceAmounts,
        null,
        {
          params: { _Params: JSON.stringify(params) },
        }
      );
      if (response.status === 200) {
        setServiceAmounts(response.data);
      }
    } catch (err) {
      console.error('Error loading UKDTC service amounts:', err);
    }
  };
    
  useEffect(() => {
    if (serviceAmounts && location.state?.otherData?.referralSource) {
      const service = serviceAmounts.find(item => item.Serivce?.includes(location.state?.otherData?.referralSource));
      setAmount(service ? service.Amount : null);
    }
  }, [serviceAmounts, location.state?.otherData?.referralSource]);

  useEffect(() => {
    if (currentStep === 1) {
      getServiceAmount();
    }
  }, [currentStep]);

  return (
    <>
      <header>
        <nav className="navbar navbar-expand-lg container-fixed">
          <a className="navbar-brand">
            <img src={WinLogo} alt="Logo" className="logo brand-logo" />
          </a>
        </nav>
      </header>

      <div className="paymentstep-page-wrapper">
        <div className="paymentstep-centered-container">
          <div className="registration-block-main patient-consent-screen paymentstep-wrapper">

            {/* Back Button */}
            <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
              <button className="win-back-btn" onClick={goBack}>
                <i className="bi bi-chevron-left"></i> Back
              </button>
            </div>

            {/* Skip Button */}
            <div className="skip-to-payment-wrapper">
              <button className="skip-payment-btn" onClick={() => navigate("/payment", 
                  {state: { updatedProviderData: updatedProviderData, otherData: {...otherData,amount:amount} }})}>
                Skip to payment &gt;&gt;&gt;
              </button>
            </div>

            <div className="registration-form-main mt-2 paymentstep-form">
              <div className="registration-form">
                <div className="registration-process-form-wrapper">

                  {/* ------------------------------------------------------ */}
                  {/* STEP 1 */}
                  {/* ------------------------------------------------------ */}
                  {currentStep === 1 && (
                    <>
                      <div className="step-content-fixed">

                        <h2 className="page-heading-primary mt-4">
                          Expert support, <br /> every step of the way
                        </h2>

                        <p className="page-description text-mute mt-3">
                          We’re delighted to welcome you to WIN.
                          For <span className="highlight">£{amount || 0}</span> per case, you'll have access
                          to a complete suite of services designed to empower and
                          guide you through your fertility journey.
                        </p>

                        <p className="text-mute mt-4">
                          <i>
                            Tap through to explore what’s included in a WIN membership,
                            or skip to payment if you're ready to begin.
                          </i>
                        </p>

                        <div className="step-image-wrap">
                          <img src={Preview1} alt="Preview 1" />
                        </div>

                      </div>

                      {/* Progress Bar */}
                      <div className="progress-dash-bar mt-4">
                        {Array.from({ length: totalSteps }).map((_, index) => (
                          <div key={index} className={`dash ${index === currentStep - 1 ? "active" : ""}`} />
                        ))}
                      </div>

                      {/* Button */}
                      <div className="paymentstep-btn-wrapper mt-5">
                        <button className="win-btn-primaryy w-100" onClick={goNext}>Next &gt;</button>
                      </div>
                    </>
                  )}

                  {/* ------------------------------------------------------ */}
                  {/* STEP 2 */}
                  {/* ------------------------------------------------------ */}
                  {currentStep === 2 && (
                        <>
                         <div className="step-content-fixed">

                         <div className="step2-layout mt-4">

                         {/* LEFT SIDE — CONTENT */}
                            <div className="step2-content">

                             <h2 className="page-heading-primary">
                             24/7 Nurse Care Advocacy
                            </h2>

                            <p className="text-mute mt-3">
                                Clinic-experienced Nurse Care Advocates offer personalised guidance to help you navigate the complexities of fertility treatment.
                                </p>

                      <ul className="text-mute mt-3">
                     <li>
                     Individualised support aligned with HFEA guidelines and WIN’s proprietary clinical protocols.
                   </li>

            <li className="mt-2">
              Help choosing a vetted, in-network provider suited to your
              needs, preferences, and values (e.g., language, LGBTQIA+ inclusivity).
            </li>

            <li className="mt-2">
              Medication guidance, including usage, storage, and side effects.
            </li>
          </ul>

        </div>

        {/* RIGHT SIDE — IMAGE */}
        <div className="step2-image">
          <img src={Preview2} alt="Step 2 Preview" />
        </div>

      </div>

    </div>

    {/* Progress Bar */}
    <div className="progress-dash-bar mt-4">
      {Array.from({ length: totalSteps }).map((_, index) => (
        <div key={index} className={`dash ${index === currentStep - 1 ? "active" : ""}`} />
      ))}
    </div>

    {/* Button */}
    <div className="paymentstep-btn-wrapper mt-5">
      <button className="win-btn-secondaryy w-100" onClick={goNext}>
        Next &gt;
      </button>
    </div>
  </>
)}


                  {/* ------------------------------------------------------ */}
                  {/* STEP 3 */}
                  {/* ------------------------------------------------------ */}
                  {currentStep === 3 && (
                    <>
                      <div className="step-content-fixed">

                        <h2 className="page-heading-primary mt-4">
                          Educational <br /> Resources
                        </h2>

                        <p className="page-description text-mute mt-3">
                          Access Expert reviewed articles and short educational videos tailored to your journey, helping you makeinformed decisions with confidence
                        </p>

                        <div className="step-image-wrap">
                          <img src={Preview3} alt="Preview 3" />
                        </div>

                      </div>

                      <div className="progress-dash-bar mt-4">
                        {Array.from({ length: totalSteps }).map((_, index) => (
                          <div key={index} className={`dash ${index === currentStep - 1 ? "active" : ""}`} />
                        ))}
                      </div>

                      <div className="paymentstep-btn-wrapper mt-5">
                        <button className="win-btn-secondaryy w-100" onClick={goNext}>Next &gt;</button>
                      </div>
                    </>
                  )}

                  {/* ------------------------------------------------------ */}
                  {/* STEP 4 */}
                  {/* ------------------------------------------------------ */}
                  {currentStep === 4 && (
                    <>
                      <div className="step-content-fixed">

                        <h2 className="page-heading-primary mt-4">
                          Financial Planning <br /> Support
                        </h2>

                        <p className="page-description text-mute mt-3">
                        WIN offers below-market discounts combining medical services and medications for a single IVF cycle.
                        </p>

                        <div className="step-image-wrap blank"></div>

                      </div>

                      <div className="progress-dash-bar mt-4">
                        {Array.from({ length: totalSteps }).map((_, index) => (
                          <div key={index} className={`dash ${index === currentStep - 1 ? "active" : ""}`} />
                        ))}
                      </div>

                      <div className="paymentstep-btn-wrapper mt-5">
                        <button className="win-btn-secondaryy w-100" onClick={goNext}>Next &gt;</button>
                      </div>
                    </>
                  )}

                  {/* ------------------------------------------------------ */}
                  {/* STEP 5 */}
                  {/* ------------------------------------------------------ */}
                  {currentStep === 5 && (
                    <>
                      <div className="step-content-fixed">

                        <h2 className="page-heading-primary mt-4">
                          Behavioural <br /> Health Support
                        </h2>

                        <p className="page-description text-mute mt-3">
                          WIN'S Behavioural Health Care Advocates provide evidence-based coping strategies to help you manage emotional challenges during your family-building journey
                        </p>

                        <div className="step-image-wrap">
                          <img src={Preview5} alt="Preview 5" />
                        </div>

                      </div>

                      <div className="progress-dash-bar mt-4">
                        {Array.from({ length: totalSteps }).map((_, index) => (
                          <div key={index} className={`dash ${index === currentStep - 1 ? "active" : ""}`} />
                        ))}
                      </div>

                      <div className="paymentstep-btn-wrapper mt-5">
                        <button className="win-btn-secondaryy w-100" onClick={goNext}>Next &gt;</button>
                      </div>
                    </>
                  )}

                  {/* ------------------------------------------------------ */}
                  {/* STEP 6 */}
                  {/* ------------------------------------------------------ */}
                  {currentStep === 6 && (
                    <>
                      <div className="step-content-fixed">

                        <h2 className="page-heading-primary mt-4">
                          Health <br /> Coaching
                        </h2>

                        <p className="page-description text-mute mt-3">
                          WIN's in-house Health Coach offers tailored dietary guidance to support your nutritional needs and optimise treatment outcomes.
                        </p>

                        <div className="step-image-wrap">
                          <img src={Preview6} alt="Preview 6" />
                        </div>

                      </div>

                      <div className="progress-dash-bar mt-4">
                        {Array.from({ length: totalSteps }).map((_, index) => (
                          <div key={index} className={`dash ${index === currentStep - 1 ? "active" : ""}`} />
                        ))}
                      </div>

                      <div className="paymentstep-btn-wrapper mt-5">
                        <button className="win-btn-secondaryy w-100" onClick={goNext}>Next &gt;</button>
                      </div>
                    </>
                  )}

                  {/* ------------------------------------------------------ */}
                  {/* STEP 7 */}
                  {/* ------------------------------------------------------ */}
                  {currentStep === 7 && (
                    <>
                      <div className="step-content-fixed">

                        <h2 className="page-heading-primary mt-4">
                          Discounted Network Access <br />
                        </h2>

                        <p className="page-description text-mute mt-3">
                          Enjoy U.K.-wide provider and pharmacy partnerships for faster access to trusted care. We continually evaluate clinics to ensure top performance, safety, and compliance.
                        </p>

                        <p className="page-description text-mute mt-3">
                          Access genetic testing when clinically appropriate, using advanced technology.
                        </p>

                        <div className="step-image-wrap blank"></div>

                      
                      </div>

                      <div className="progress-dash-bar mt-4">
                        {Array.from({ length: totalSteps }).map((_, index) => (
                          <div key={index} className={`dash ${index === currentStep - 1 ? "active" : ""}`} />
                        ))}
                      </div>

                      <div className="paymentstep-btn-wrapper mt-5">
                        <button className="win-btn-secondaryy w-100" onClick={goNext}>Next &gt;</button>
                      </div>
                    </>
                  )}

                  {/* ------------------------------------------------------ */}
                  {/* STEP 8 */}
                  {/* ------------------------------------------------------ */}
                  {currentStep === 8 && (
  <>
    <div className="step-content-fixed">

      <div className="step2-layout mt-4">

        <div className="step2-content">
          <h2 className="page-heading-primary">WIN Family App</h2>

          <p className="text-mute mt-3">Your digital companion for convenient support:</p>

          <ul className="text-mute mt-3">
            <li>Schedule nurse consults by phone, video, or real-time chat.</li>
            <li className="mt-2">Track cycles, ovulation, and fertility indicators.</li>
            <li className="mt-2">
              Use our pricing tools to estimate and monitor treatment costs.
            </li>
          </ul>
        </div>

        <div className="step2-image">
          <img src={Preview8} alt="Step 8 Preview" />
        </div>

      </div>

    </div>

    {/* Progress Bar */}
    <div className="progress-dash-bar mt-4">
      {Array.from({ length: totalSteps }).map((_, index) => (
        <div key={index} className={`dash ${index === currentStep - 1 ? "active" : ""}`} />
      ))}
    </div>

    {/* Button */}
    <div className="paymentstep-btn-wrapper mt-5">
      <button
        className="win-btn-secondaryy w-100"
        onClick={() => goNext()}
      >
        Next &gt;
      </button>
    </div>
  </>
)}

                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default Paymentstep;
